var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { StatusReasonClientService } from "../../../../services/status-reason/status-reason-client.service";
import { autoinject, BindingEngine } from "aurelia-framework";
import * as Enumerable from "linq";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
var ManageStatusReasonTransaction = /** @class */ (function () {
    function ManageStatusReasonTransaction(statusReasonClienttService, bindingEngine, notificationClientService) {
        var _this = this;
        this.statusReasonClienttService = statusReasonClienttService;
        this.bindingEngine = bindingEngine;
        this.notificationClientService = notificationClientService;
        this.entityTypes = [];
        this.statusReasonTransitions = [];
        this.statusReasons = [];
        this.statusesByEntityType = {};
        this.statusReasonsByStatusId = {};
        this.statusReasonTransitionsByEntityType = {};
        this.setupTransitions = function (response) {
            if (_this._uow) {
                _this._uow.clearChanges();
                _this._uow.dispose();
            }
            _this.statusReasonTransitionsByEntityType = {};
            _this.statusReasonsByStatusId = {};
            _this.statusesByEntityType = {};
            _this.entityTypes = response.entityTypes;
            _this.statusReasons = response.statusReasons;
            _this.statusReasonTransitions = response.statusReasonTransitions;
            response.statusReasonTransitions.forEach(function (transition) {
                if (transition.currentStatusReasonId) {
                    var entityTypeId = _this.statusReasons.filter(function (y) { return y.statusReasonId == transition.currentStatusReasonId; })[0].status.entityTypeId;
                    if (!_this.statusReasonTransitionsByEntityType[entityTypeId]) {
                        _this.statusReasonTransitionsByEntityType[entityTypeId] = [];
                    }
                    _this.statusReasonTransitionsByEntityType[entityTypeId].push(transition);
                }
                else {
                    var entityTypeId = _this.statusReasons.filter(function (y) { return y.statusReasonId == transition.nextStatusReasonId; })[0].status.entityTypeId;
                    if (!_this.statusReasonTransitionsByEntityType[entityTypeId]) {
                        _this.statusReasonTransitionsByEntityType[entityTypeId] = [];
                    }
                    _this.statusReasonTransitionsByEntityType[entityTypeId].push(transition);
                }
            });
            _this.statusReasonsByStatusId = Enumerable.from(response.statusReasons).groupBy(function (x) { return x.statusId; }).toObject(function (x) { return x.key(); }, function (x) {
                var array = x.toArray();
                array.unshift({ statusId: x.key(), statusReasonId: 0, name: "" });
                return array;
            });
            _this.statusesByEntityType = Enumerable.from(_this.statusReasons).select(function (x) { return x.status; }).distinct(function (x) { return x.statusId; }).groupBy(function (x) { return x.entityTypeId; })
                .toObject(function (x) { return x.key(); }, function (x) {
                var array = x.toArray();
                array.unshift({ entityTypeId: x.key(), statusId: 0, name: "" });
                return array;
            });
            _this.entityTypes.forEach(function (entityType) {
                if (!_this.statusReasonTransitionsByEntityType[entityType.entityTypeId]) {
                    _this.statusReasonTransitionsByEntityType[entityType.entityTypeId] = [];
                }
                _this.statusReasonTransitionsByEntityType[entityType.entityTypeId] = Enumerable.from(_this.statusReasonTransitionsByEntityType[entityType.entityTypeId]).orderBy(function (x) { return x.sequenceNumber; }).toArray();
            });
            _this._uow = UnitOfWorkObserver.getTrackingInstance(_this.bindingEngine, _this.statusReasonTransitions, ["currentStatusReason", "nextStatusReason"]);
        };
    }
    ManageStatusReasonTransaction.prototype.activate = function () {
        this.statusReasonClienttService.getStatusReasonTransitions().then(this.setupTransitions);
    };
    ManageStatusReasonTransaction.prototype.save = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.statusReasonClienttService.save(_this._uow.getChanges()).then(function (response) {
                _this.setupTransitions(response);
                _this.notificationClientService.show("Save", "Transitions saved successfully", NotificationType.Success);
                resolve();
            }, function (e) {
                reject();
                _this.notificationClientService.show("Save", "Failed to save Transitions", NotificationType.Error);
            });
        });
    };
    ManageStatusReasonTransaction.prototype.addTransition = function (entityTypeId) {
        var transition = {
            currentStatusReasonId: null,
            isInternal: false,
            nextStatusReasonId: 0,
            permissionId: null,
            sequenceNumber: 0,
            statusReasonTransitionId: 0
        };
        this.statusReasonTransitionsByEntityType[entityTypeId].push(transition);
        this.statusReasonTransitions.push(transition);
    };
    ManageStatusReasonTransaction.prototype.deleteTransition = function (transition, entityTypeId) {
        var index = this.statusReasonTransitionsByEntityType[entityTypeId].findIndex(function (x) { return x == transition; });
        if (index > -1) {
            this.statusReasonTransitionsByEntityType[entityTypeId].splice(index, 1);
        }
        index = this.statusReasonTransitions.findIndex(function (x) { return x == transition; });
        if (index > -1) {
            this.statusReasonTransitions.splice(index, 1);
        }
    };
    ManageStatusReasonTransaction = __decorate([
        autoinject,
        __metadata("design:paramtypes", [StatusReasonClientService, BindingEngine,
            NotificationClientService])
    ], ManageStatusReasonTransaction);
    return ManageStatusReasonTransaction;
}());
export { ManageStatusReasonTransaction };
